import { INeoAction } from './../Actions.interface';
import {
  REQUEST_ACTIONS,
  CUSTOMER_PROFILE_ACTIONS,
  STATUS,
} from '../../Constants/Actions.constants';
import { FullCustomer } from '../../Models/DTO/Customer.model';

export interface CustomerProfilesState {
  profile: FullCustomer | null;
  invitationSent: boolean;
  customerDisconnected: boolean;
}

const INITIAL_STATE = {
  profile: null,
  invitationSent: false,
  customerDisconnected: false,
};

export default (
  state: CustomerProfilesState = INITIAL_STATE,
  action: INeoAction,
): CustomerProfilesState => {
  const { name, status, payload } = action;

  if (name === CUSTOMER_PROFILE_ACTIONS.CLEAR_SELECTED_CUSTOMER) {
    return {
      ...state,
      profile: null,
    };
  }

  if (status === STATUS.SUCCESS) {
    if (name === REQUEST_ACTIONS.SINGLE_CUSTOMER) {
      return {
        customerDisconnected: false,
        invitationSent: false,
        profile: payload,
      };
    }

    if (name === REQUEST_ACTIONS.UPDATE_CUSTOMER) {
      return {
        customerDisconnected: false,
        invitationSent: false,
        profile: payload,
      };
    }

    if (name === REQUEST_ACTIONS.INVITE_CUSTOMER) {
      return {
        ...state,
        invitationSent: true,
      };
    }

    if (name === REQUEST_ACTIONS.DISCONNECT_CUSTOMER) {
      return {
        ...state,
        customerDisconnected: true,
      };
    }
  }
  return state;
};
